/**
 * Pieces every numbered-box ICS card reuses, so the 202, 209 and 233 present a
 * read-only box the same way rather than each growing its own copy.
 *
 * The box chrome itself lives in `Ics204CardSection`; these are what goes
 * inside one and beside its title.
 */
import React from 'react';
import { InfoIcon } from 'lucide-react';

import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip';
import { NULL_VALUE } from 'constants/displayConstants';

/** The info affordance a numbered box hangs off its title, as the 204 does. */
export const BoxInfo: React.FC<{
  label: string;
  children: React.ReactNode;
}> = ({ label, children }) => (
  <TooltipProvider>
    <Tooltip>
      <TooltipTrigger
        render={
          <span
            role="button"
            tabIndex={0}
            aria-label={label}
            className="tw:inline-flex tw:shrink-0 tw:text-[var(--text-weak)]"
          >
            <InfoIcon className="tw:size-4" />
          </span>
        }
      />
      <TooltipContent side="bottom" className="tw:max-w-xs">
        {children}
      </TooltipContent>
    </Tooltip>
  </TooltipProvider>
);

/** Read-only box content, matching `Ics204ReadOnlyField`'s treatment. */
export const PrintedValue: React.FC<{ value: string; testId: string }> = ({
  value,
  testId,
}) => (
  <span
    className="tw:block tw:min-w-0 tw:break-words tw:text-foreground"
    data-testid={testId}
  >
    {value.trim() ? value : NULL_VALUE}
  </span>
);
